import React from 'react';
import { Modal, ModalProps, Text } from '@mantine/core';

interface ModalPopupComponentProps extends Omit<ModalProps, 'onClose'> {
  children?: React.ReactNode;
  opened: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
  close: () => void;
  title?: React.ReactNode;
}

const ModalPopupComponent: React.FC<ModalPopupComponentProps> = ({
  children,
  opened,
  size = 'md',
  close,
  title,
  withCloseButton = false,
  closeOnClickOutside = false,
  ...props
}) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      size={size}
      centered
      title={
        typeof title === 'string' ? (
          <Text c={'dark'} fw={700} fz={24}>
            {title}
          </Text>
        ) : (
          <>{title}</>
        )
      }
      closeOnClickOutside={closeOnClickOutside}
      withCloseButton={withCloseButton}
      overlayProps={{
        blur: 6,
        opacity: 1
      }}
      radius={16}
      padding={32}
      {...props}
    >
      {children}
    </Modal>
  );
};

export default ModalPopupComponent;
